if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        // ===== 【修复】移除原生 submit 监听，交给 main-product.liquid 里的全局劫持脚本处理 =====
        // （这样可以避免两个 AJAX 加购同时触发，也避免了 !this.cart 时 window.location=/cart 的跳转子弹）
        // this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        // 同上：移除原生 click 监听
        // this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            const span = this.submitButton.querySelector('span');
            if (span) span.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          // ===== 【修复】去掉 !this.cart 时 window.location=/cart 的跳转兜底 =====
          // 即使找不到 cart-notification / cart-drawer，也绝不跳转页面。
          // 改为：尝试注入/刷新 cart-drawer 并打开（走全局刷新逻辑）
          if (!this.cart) {
            try {
              if (window.__kg_try_open_drawer) {
                window.__kg_try_open_drawer();
              } else {
                // 兜底：手动刷新并打开
                fetch(window.routes.cart_url + '?section_id=cart-drawer', { credentials: 'same-origin' })
                  .then(function(r) { return r.text(); })
                  .then(function(html) {
                    try {
                      var doc = new DOMParser().parseFromString(html, 'text/html');
                      var n = doc.querySelector('cart-drawer');
                      var o = document.querySelector('cart-drawer');
                      if (n && o) o.innerHTML = n.innerHTML, o.setAttribute('class', n.getAttribute('class') || 'drawer');
                      else if (n) document.body.insertAdjacentHTML('beforeend', n.outerHTML);
                      var d = document.querySelector('cart-drawer');
                      if (d) {
                        d.classList.remove('is-empty');
                        if (typeof d.open === 'function') d.open();
                        else d.classList.add('animate', 'active'), document.body.classList.add('overflow-hidden');
                      }
                    } catch (e) {}
                  });
              }
            } catch (e) {}
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;

      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
